<template>
    <div class="mobile-layout">
        <main class="mobile-layout__content" :class="{'mobile-layout__content--with-tab': !$route.meta.hideMobileTabBar}">
            <router-view></router-view>
        </main>
        <mobile-tab-bar v-if="!$route.meta.hideMobileTabBar"></mobile-tab-bar>
    </div>
</template>

<script>
import '@/components/mobile/vant';
import MobileTabBar from '@/components/mobile/common/tab-bar.vue';
import storage from '@/utils/storage';

export default {
    name: 'MobileLayout',
    components: {
        MobileTabBar,
    },
    created() {
        const userData = storage.userData();
        const permission = storage.permission();
        if (userData) {
            this.$store.dispatch('userData', userData);
        }
        if (Array.isArray(permission)) {
            this.$store.dispatch('permission', permission);
        }
    },
};
</script>

<style scoped lang="less">
.mobile-layout {
    min-height: 100%;
    background: #f5f7fa;
}

.mobile-layout__content {
    min-height: 100vh;
    box-sizing: border-box;
}

.mobile-layout__content--with-tab {
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
}
</style>
